import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainAclComponent } from './main-acl/main-acl.component';

const routes: Routes = [
  {
    path: '',
    component: MainAclComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'catalog/acl' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AclRoutingModule {}
